import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid-pickup-delivery',
  templateUrl: './covid-pickup-delivery.component.html',
  styleUrls: ['./covid-pickup-delivery.component.less']
})
export class CovidPickupDeliveryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
